export default __webpack_public_path__ + "static/media/about.32addfb3.jpg";